import type { JSX } from 'react';

/**
 * Re-centre the COP camera on a selected incident (#356). Fire / hotspot / CAP
 * markers are "context" selections that don't auto-fly on click (unlike anomalies),
 * so their panels need an explicit jump. Mirrors the EvacuationBody / CommunityBody
 * "Fly to incident" affordance and reuses the same flyToIncident controller.
 *
 * Extracted from SidePanel (#388) so the drone-mission detail panel can reuse the
 * exact same control for its incident back-ref without a SidePanel ↔ panel-body
 * import cycle. Self-hides (returns null) when no `onFlyToIncident` is wired.
 */
export function FlyToIncidentButton({
  lat,
  lon,
  onFlyToIncident,
  label = 'Fly to incident',
}: {
  lat: number;
  lon: number;
  onFlyToIncident?: (lat: number, lon: number) => void;
  label?: string;
}): JSX.Element | null {
  if (!onFlyToIncident) return null;
  return (
    <button
      type="button"
      data-testid="fly-to-incident"
      onClick={() => onFlyToIncident(lat, lon)}
      className="w-full rounded bg-slate-700 hover:bg-slate-600 border border-slate-600 px-3 py-2 text-sm font-medium text-slate-100 flex items-center justify-center gap-1.5"
    >
      <span aria-hidden>🎯</span> {label}
    </button>
  );
}
